import { CheckSquareOutlined, CloseSquareOutlined, EditOutlined } from "@ant-design/icons";
import { Card, Input, message, Modal, Table, Tag } from "antd";
import ReusableButton from "components/Elements/ReusableButton";
import EllipsisDropdown from "components/shared-components/EllipsisDropdown";
import network from "network/network";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";



const ActivityStatus = ({ changeTab }) => {


    const [activities, setActivities] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [activityDesc, setActivityDesc] = useState("");
    const [selectedActivity, setSelectedActivity] = useState();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        selectActivities();
    })

    const selectActivities = async () => {
        var result = await network.get("/admin/Activity/getAllActivities", false);
        if (!result.isSuccess) {
            message.error(result.errorMessage);
        }
        else {
            if (!result.data.isSuccess) {
                message.error(result.data.errorMessage);
            } else {
                setActivities(result.data.data.reverse());
            }
        }
    }

    const addOrUpdateNewActivity = async () => {

        if (!selectedActivity) {
            var params = {
                activitydesc: activityDesc,
                status: true
            }
            var result = await network.post("/admin/Activity/addActivity", params, false);

            if (!result.isSuccess) {
                message.error(result.errorMessage);
            }
            else {
                if (!result.data.isSuccess) {
                    message.error(result.data.errorMessage);
                } else {
                    message.success(t("successActivityadd"))
                    setIsModalVisible(false);
                    setActivityDesc("");
                }
            }
        } else {

            var params = {
                activityid: selectedActivity.activityid,
                activitydesc: activityDesc,
                status: selectedActivity.status
            }
            var result = await network.post("/admin/Activity/updateActivity", params, false);

            if (!result.isSuccess) {
                message.error(result.errorMessage);
            }
            else {
                if (!result.data.isSuccess) {
                    message.error(result.data.errorMessage);
                } else {
                    message.success(t("successActivity"))
                    setIsModalVisible(false);
                    setActivityDesc("");
                }
            }
        }


    }


    const dropdownMenu = (record) => {
        return [
            {
                label: (<span >{!record.status ? t('active') : t('inactive')}</span>),
                key: '1',
                icon: !record.status ? <CheckSquareOutlined /> : <CloseSquareOutlined />,
                onClick: () => handleStatusChange(record)
            },
            {
                label: (<span >{t('edit')}</span>),
                key: '2',
                icon: <EditOutlined />,
                onClick: () => {
                    setIsModalVisible(true);
                    setSelectedActivity(record);
                    setActivityDesc(record.activitydesc)
                }
            }
        ]
    };

    const handleStatusChange = async (value) => {

        var params = {
            activityid: value.activityid,
            status: !value.status,
        }

        var result = await network.post("/admin/Activity/updateActivity", params);

        if (result.isSuccess) {
            message.success(t("successActivity"));
            selectActivities();
        }
    }

    const tableColumns = [
        {
            title: t("activityDesc"),
            dataIndex: "activitydesc",
            key: "activitydesc",
            render: (_, record) =>
                <div style={{ width: "200px" }} >
                    {record.activitydesc}
                </div>

        },
        {
            title: t("status"),
            dataIndex: "status",
            key: "status",
            render: (_, record) =>
                <div style={{ width: "200px" }} >
                    {record.status === true ? (
                        <Tag color={"green"}>Aktif</Tag>
                    ) : (
                        <Tag color={"red"}>Pasif</Tag>
                    )}
                </div>

        },
        {
            dataIndex: "",
            render: (_, record) => (
                <div>
                    <EllipsisDropdown menu={{ items: dropdownMenu(record) }} />
                </div>
            )
        }




    ]

    return (
        <>
            <div className="mb-2" style={{ display: "flex", width: "100%", justifyContent: "end" }}>
                <div>
                    <ReusableButton variant={"campaign"} text={t("addActivity")} onClick={() => setIsModalVisible(true)} />
                </div>
            </div>
            <Card>
                <Table

                    columns={tableColumns}
                    dataSource={activities}
                />
            </Card>


            <Modal closable={false} title={t("addEditAct")} closeIcon={false} open={isModalVisible} onCancel={() => {

                setIsModalVisible(false)
                setActivityDesc();
            }} onOk={addOrUpdateNewActivity}>

                <Input value={activityDesc} placeholder={t("writeActivity")} onChange={(event) => setActivityDesc(event.target.value)}></Input>
            </Modal>
        </>
    )
}

export default ActivityStatus;